<template>
  <div class="CommonContentSingle-white">
    <el-button type="primary" @click="add">{{ $t('original.languages288') }}</el-button>

    <el-table :data="tableData" style="width: 100%; margin-top: 10px;">
      <el-table-column :label="$t('original.The_serial_number')" align="left" width="60px">
        <template slot-scope="scope" center>
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('original.languages289')" min-width="20%">
        <template slot-scope="scope">
          <span style="margin-left: 10px;">{{ scope.row.Types }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('original.languages290')" min-width="25%">
        <template slot-scope="scope">
          <span style="">
            {{ scope.row.StartDate }}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages291')" min-width="25%">
        <template slot-scope="scope">
          <span style="">
            {{ scope.row.FinishDate }}
          </span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('original.languages49')" min-width="25%">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">
            {{ $t('original.editor') }}
          </el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
            {{ $t('original.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer :title="$t('original.languages292')" :visible.sync="drawer" :with-header="false" class="drawer" :size="'500px'">
      <el-form class="drawer_from" ref="form" style="100%" label-width="130px">
        <el-form-item :label="$t('original.languages289')">
          <el-col>
            <el-date-picker class="picker-150" v-model="formTermDeploy.StartYear" type="year" value-format="yyyy" format="yyyy" :placeholder="$t('original.languages293')"></el-date-picker>
            至
            <el-date-picker class="picker-150" v-model="formTermDeploy.EndYear" type="year" value-format="yyyy" format="yyyy" :placeholder="$t('original.languages294')"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item :label="$t('original.languages295')">
          <el-col>
            <el-date-picker v-model="formTermDeploy.StartDate" type="date" :placeholder="$t('original.languages293')" value-format="yyyy-MM-dd"></el-date-picker>
             {{ $t('original.languages293') }}
             
            <el-date-picker :picker-options="pickerOptions" v-model="formTermDeploy.xaxax" type="date" :placeholder="$t('original.languages294')" value-format="yyyy-MM-dd"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="xa" type="primary" @click="saveTerm">{{ $t('original.save') }} </el-button>
          <el-button @click="close"> {{ $t('original.cancel') }}</el-button>
        </el-form-item>
      </el-form>

    </el-drawer>

    <el-drawer :title="$t('original.languages297')" :visible.sync="drawer1" :with-header="false" :size="'500px'">

      <el-form class="drawer_from" ref="formTermDeployAdd" :model="formTermDeployAdd" :rules="rules" label-width="130px">

        <el-form-item :label="$t('original.languages289')" prop="TermYear">
          <el-col>
            <el-date-picker class="picker-150" v-model="formTermDeployAdd.StartYear" type="year" value-format="yyyy" format="yyyy" :placeholder="$t('original.languages293')"></el-date-picker>
            {{ $t('original.languages296') }}
            <el-date-picker class="picker-150" v-model="formTermDeployAdd.EndYear" type="year" value-format="yyyy" format="yyyy" :placeholder="$t('original.languages294')"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item :label="$t('original.languages295')" prop="Termtime">
          <el-col>
            <el-date-picker v-model="formTermDeployAdd.StartDate" type="date" :placeholder="$t('original.languages293')" value-format="yyyy-MM-dd"></el-date-picker>
            {{ $t('original.languages296') }}
            <el-date-picker v-model="formTermDeployAdd.FinishDate" type="date" value-format="yyyy-MM-dd" :placeholder="$t('original.languages294')"></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="xa" type="primary" @click="addsaveTerm('formTermDeployAdd')">

            {{ $t('original.save') }}
          </el-button>
          <el-button @click="close">{{ $t('original.cancel') }}</el-button>
        </el-form-item>

      </el-form>

    </el-drawer>
  </div>
</template>
<style>
.drawer_from {
  padding-top: 30px;
}
</style>

<script>
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
        }
      },
      xa:false,
      FinishDate2:'',
      drawer: false,
      drawer1: false,
      tableData: [], //表格数组
      sortingss: '',
      create_time: '',
      formTermDeploy: {
        TermYM: '',
        StartYear: '', //年份
        EndYear: '', //年份
        StartDate: '', // 开始时间
        FinshDate: '', // 学期结束时间
        xaxax:''
      },
      formTermDeployAdd: {
        TermYM: '',
        StartYear: '', //年份
        EndYear: '', //年份
        StartDate: '', // 开始时间
        FinshDate: '', // 学期结束时间
      },
      rules: {
        TermYear: [
          { required: true, message: this.$t('original.languages298'), trigger: 'change' },
        ],
        Type: [{ required: true, message: this.$t('original.languages299'), trigger: 'change' }],
        Termtime: [
          {
            required: true,
            message: this.$t('original.languages300'),
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    loading(val, type, numder, sortingss, create_time) {
      //表格数据获取接口
      var from = {
        DeptID: val,
        DeptName: type,
      }

      this.$Http_Post('ConsultSubscribe/ShowTermDeploy', {
        pageSize: '10',
        pageIndex: numder,
        type: this.types,
        sort: sortingss,
        datasort: create_time,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data
          this.Counts = Number(res.Counts)
        } else {
          this.$message({
            type: 'success',
            message: this.$t('original.languages301'),
          })
        }
      })
    },
    close() {
      this.drawer = false;
      this.drawer1 = false;
    },
    handleDelete(row) {
      this.$confirm(this.$t('original.languages302'), this.$t('original.languages63'), {
        confirmButtonText: this.$t('original.languages59'),
        cancelButtonText:  this.$t('original.cancel'),
        type: 'warning',
      })
        .then(() => {
          this.$Http_Post('ConsultSubscribe/DeleTermDeploy', {
            TermYM: row.TermYM,
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.$message({
                type: 'success',
                message: this.$t('original.languages303'),
              })
              this.loading('', '', '1', this.sortingss, this.create_time)
            } else {
              this.Global.request_failure(res.Message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('original.languages160'),
          })
        })
    },
    handleEdit(row) {
      //修改反写
      this.drawer = true
      this.$Http_Post('ConsultSubscribe/ShowTermDeploy', {
        TermYM: row.TermYM,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.formTermDeploy.TermYM = res.Data[0].TermYM;
          this.formTermDeploy.StartYear = res.Data[0].StartYear;
          this.formTermDeploy.EndYear = res.Data[0].EndYear;
          this.formTermDeploy.StartDate = res.Data[0].StartDate;
          this.formTermDeploy.xaxax = res.Data[0].FinishDate;
        } else {
          this.Global.request_failure(res.Message)
        }
      })
    },
    saveTerm() {
      this.xa = true;
      this.$Http_Post('ConsultSubscribe/UppTermDeploy', {
        TermYM: this.formTermDeploy.TermYM,
        StartYear: this.formTermDeploy.StartYear,
        EndYear: this.formTermDeploy.EndYear,
        StartDate: this.formTermDeploy.StartDate,
        FinishDate: this.formTermDeploy.xaxax,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xa = false;
          this.drawer = false
          this.$message({
            type: 'success',
            message: this.$t('original.languages304'),
          })
          this.loading('', '', '1', this.sortingss, this.create_time)
        } else {
          this.xa = false;
          this.Global.request_failure(res.Message)
        }
      })
    },
    addsaveTerm(formName) {
      this.xa = true;
      let message = ''
      if (this.formTermDeployAdd.StartYear == '' || this.formTermDeployAdd.EndYear == '') {
        message = this.$t('original.languages299')
        this.xa = false;
      } else if (this.formTermDeployAdd.StartDate == '' || this.formTermDeployAdd.FinishDate == '') {
        message = this.$t('original.languages305')
        this.xa = false;
      } else message = ''

      if (message == '') {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$Http_Post('ConsultSubscribe/AddTermDeploy',this.formTermDeployAdd).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.xa = false;
                 (this.drawer1 = false),
                  this.$message({ type: 'success', message: this.$t('original.languages306') });
                  this.loading('', '', '1', this.sortingss, this.create_time);
              } else {
                this.xa = false;
                this.$message({
                  type: 'warning',
                  message: res.Message,
                })
                this.$refs[formName].resetFields()
              }
            })
          } else {
            return false
          }
        })
      } else this.Global.request_info(message)
    },
    add() {
      this.drawer1 = true;
      this.formTermDeployAdd.TermYM = ' ';
      this.formTermDeployAdd.TermYear = ' ';
      this.formTermDeployAdd.Type = ' ';
      this.formTermDeployAdd.StartTime = ' ';
      this.formTermDeployAdd.FinishTime = ' ';
      this.formTermDeployAdd.Termtime = ' ';
    },
  },
  mounted() {
    this.loading('', '', '1', this.sortingss, this.create_time);
  },
}
</script>

<style>
  .CommonContentSingle-white td{text-align: center;}
</style>
